<template>
<!--S 关于我们   -->
<section class="wraper">
  <div class="banner">
<img src="../../../assets/images/aboutOur/banner.jpg" width="100%">
  </div>
  <div class="container">
    <h3 class="title">
      <span>公司发展</span>
    </h3>
    <p class="title-sub">科学，创新进取，专业高效，诚信服务</p>
    <hr>
    <!-- <Title :title="title.tit1"></Title> -->
    <p v-html="content">
    </p>
    <!-- <Title :title="title.tit2"></Title>
    <p>
      电视里看风景二手房撒发解放路快速的家乐福是的拉风进来撒娇地方老师讲道理记录例如 i设计案发 
    </p>
    <Title :title="title.tit3"></Title>-->
    <p></p> 
  </div>
</section>
</template>
<script>
import { post, get } from "@/axios/index";
import Title from '@/components/common/title'
export default {
  components: {
    Title
  },
  data() {
    return {
      aboutus:{},
      title: {tit1: '创立起源',tit2:'发展导向',tit3:'未来展望'},
      content:''
    }
  },
  methods: {

  },
    mounted() {
    //获取关于我们，联系我们
    get("/stkaboutus/getaboutusinfo", {}).then(
      response => {
        this.content = response.data.result.name;
      },
      err => {
        console.log(err);
        this.$message({
          type: "error",
          message: "error"
        });
      }
    );
  }
}
</script>
<style lang="less" scoped>
.wraper {
  width: 100%;
  height: 100%;
  .banner {
    // width: 100%;
    // height: 360px;
    // overflow: hidden;
    // background: url('../../../assets/images/aboutOur/banner.jpg') left center no-repeat;
    // background-size: 100% 100%;
  }
  .container {
    width: 1060px;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    .title {
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
      position: relative;
      margin-top: 20px;
      span {
        font-family: AdobeHeitiStd-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 2px;
        color: #4a4a4a;
        display: inline-block;
        padding: 0 33px;
        background-color: #fcfcfc;
        position: relative;
      }
    }
    .title-sub {
      width: 100%;
      text-align: center;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 2px;
      margin-top: 11px;
      margin-bottom: 11px;
      .color333;
    }
    // h3 {
    //   font-size: 18px;
    //   font-weight: bold;
    //   line-height: 30px;
    //   color: #2ba0fe;
    // }
    hr {
      margin-bottom: 20px;
    }
    p {
      line-height: 30px;
      text-align: justify;
      text-indent: 32px;
      &:last-child {
        margin-bottom: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/aboutOur/index.vue